import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { DesktopPickerMap, MobilePickerMap } from './Picker.constants';
import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

export const usePickerLogic = (selectedMenuItem: SELECTED_MENU_ITEMS) => {
  const { isDesktop } = useResponsiveScreen();
  return isDesktop
    ? (DesktopPickerMap[selectedMenuItem] ?? DesktopPickerMap[SELECTED_MENU_ITEMS.Computer])
    : (MobilePickerMap[selectedMenuItem] ?? MobilePickerMap[SELECTED_MENU_ITEMS.Gallery]);
};
